import OTPField from "../../../ui/fields/OTPField";

const LoginVerifyView = ({
  formData,
  setFormData,
  loginState,
  handleVerifyOTP,
  onResend,
  handleOnBack,
  isActionLoading,
  resendTimer,
}) => {
  return (
    <OTPField
      value={formData.confirmationCode}
      onChange={(val) => setFormData((p) => ({...p, confirmationCode: val}))}
      isActionLoading={isActionLoading}
      onAction={handleVerifyOTP}
      onResend={onResend}
      actionLabel="Verify code"
      onBack={handleOnBack}
      resendTimer={resendTimer}
      loginState={loginState}
    />
  );
};

export default LoginVerifyView;
